import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import MortgageNote, {
  FetchNotesParams,
} from "../interfaces/mortgageNote.redux.interface";

interface MortgageNotesState {
  notes: MortgageNote[];
  status: "idle" | "loading" | "failed";
  hasMore: boolean;
}

const initialState: MortgageNotesState = {
  notes: [],
  status: "idle",
  hasMore: true,
};

export const fetchMortgageNotes = createAsyncThunk(
  "mortgageNotes/fetchMortgageNotes",
  async (filters: FetchNotesParams = {}) => {
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/mortgageNotes/note/fetch`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...filters,
          limit: filters.limit || 10,
          offset: filters.offset || 0,
        }),
      }
    );
    const data = await response.json();
    return data as MortgageNote[];
  }
);

export const mortgageNotesSlice = createSlice({
  name: "mortgageNotes",
  initialState,
  reducers: {
    setMortgageNotes: (state, action: PayloadAction<MortgageNote[]>) => {
      state.notes = action.payload;
    },
    addMortgageNotes: (state, action: PayloadAction<MortgageNote>) => {
      state.notes.push(action.payload);
    },
    appendMortgageNotes: (state, action: PayloadAction<MortgageNote[]>) => {
      state.notes = [...state.notes, ...action.payload];
    },
    setLoadingStatus: (state) => {
      state.status = "loading";
    },
    setIdleStatus: (state) => {
      state.status = "idle";
    },
    setFailedStatus: (state) => {
      state.status = "failed";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMortgageNotes.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchMortgageNotes.fulfilled, (state, action) => {
        if (action?.meta?.arg?.offset === 0) {
          state.notes = action.payload;
        } else {
          state.notes = [...state.notes, ...action.payload];
        }
        state.status = "idle";
        state.hasMore =
          action.payload.length === (action?.meta?.arg?.limit || 10);
      })
      .addCase(fetchMortgageNotes.rejected, (state) => {
        state.status = "failed";
      });
  },
});

// Export actions for use in components
export const {
  setMortgageNotes,
  addMortgageNotes,
  appendMortgageNotes,
  setLoadingStatus,
  setIdleStatus,
  setFailedStatus,
} = mortgageNotesSlice.actions;

export default mortgageNotesSlice.reducer;
